//
// Copyright © 2020 Anticrm Platform Contributors.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//

import { loadMetadata } from '@hcengineering/platform'
import recruit from '@hcengineering/recruit'

const icons = require('../assets/icons.svg') as string // eslint-disable-line
loadMetadata(recruit.icon, {
  RecruitApplication: `${icons}#recruitment`,
  Vacancy: `${icons}#vacancy`,
  Location: `${icons}#location`,
  Calendar: `${icons}#calendar`,
  Create: `${icons}#create`,
  Application: `${icons}#application`,
  Review: `${icons}#review`,
  Opinion: `${icons}#opinion`,
  CreateCandidate: `${icons}#new-candidate`,
  AssignedToMe: `${icons}#assignedToMe`,
  Reviews: `${icons}#reviews`,
  Skills: `${icons}#skills`,
  Issue: `${icons}#issue`,
  Schedule: `${icons}#schedule`,
  Talents: `${icons}#talents`
})
